module.exports = __webpack_public_path__ + "dist/img/banner.9d07e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 1